import React from "react";
import { InlineMath } from "../../../../components/math/KatexWrappers";
import {
  formatLatexPreview,
  parseFractionLikeInput,
} from "../../../../components/inputs/FractionInput";

export function randInt(min, max) {
  return min + Math.floor(Math.random() * (max - min + 1));
}

export function pick(values) {
  return values[Math.floor(Math.random() * values.length)];
}

export function signedNumberLatex(value) {
  if (value < 0) return `- ${Math.abs(value)}`;
  return String(value);
}

export function formatNumberLatex(value) {
  if (Number.isInteger(value)) return String(value);
  return String(value).replace(".", ",");
}

export function fractionLatex(numerator, denominator) {
  const sign = numerator * denominator < 0 ? "-" : "";
  return `${sign}\\frac{${Math.abs(numerator)}}{${Math.abs(denominator)}}`;
}

export function termLatex(coefficient, degree, first = false) {
  if (coefficient === 0) return "";
  const sign = coefficient < 0 ? "-" : "+";
  const abs = Math.abs(coefficient);
  let body;

  if (degree === 0) {
    body = String(abs);
  } else {
    const coef = abs === 1 ? "" : String(abs);
    const power = degree === 1 ? "x" : `x^{${degree}}`;
    body = `${coef}${power}`;
  }

  if (first) return coefficient < 0 ? `-${body}` : body;
  return `${sign} ${body}`;
}

export function polynomialLatex(terms) {
  const sorted = [...terms]
    .filter((term) => term.coefficient !== 0)
    .sort((a, b) => b.degree - a.degree);

  if (!sorted.length) return "0";
  return sorted
    .map((term, index) => termLatex(term.coefficient, term.degree, index === 0))
    .join(" ");
}

export function evaluatePolynomial(terms, x) {
  return terms.reduce((sum, term) => sum + term.coefficient * x ** term.degree, 0);
}

export function leadingTerm(terms) {
  return [...terms]
    .filter((term) => term.coefficient !== 0)
    .sort((a, b) => b.degree - a.degree)[0];
}

export function constantTerm(terms) {
  return terms.find((term) => term.degree === 0)?.coefficient ?? 0;
}

export function numberAnswer(value) {
  if (value && typeof value === "object") {
    if (Number.isFinite(value.parsed)) return value.parsed;
    if (typeof value.raw === "string") return numberAnswer(value.raw);
  }

  if (typeof value === "number") return value;
  if (typeof value !== "string") return NaN;

  const parsed = parseFractionLikeInput(value);
  return Number.isFinite(parsed) ? parsed : NaN;
}

export function isCorrectNumber(value, expected, epsilon = 1e-9) {
  const parsed = numberAnswer(value);
  return Number.isFinite(parsed) && Math.abs(parsed - expected) <= epsilon;
}

export function renderPreview(value, label) {
  const raw = value && typeof value === "object" ? value.raw : value;
  if (!raw) return <em>brak odpowiedzi</em>;
  return <InlineMath math={formatLatexPreview(raw, label)} />;
}

export function taskTags(extra = []) {
  return ["algebra", "wielomiany", "pojecie_wielomianu", ...extra];
}
